import { TypographyOptions } from '@material-ui/core/styles/createTypography';

const fontFamily = 'Roboto, Lora, sans-serif';

export const typography: TypographyOptions = {
  fontFamily,
  h1: {
    fontFamily: 'Lora, sans-serif',
    fontSize: 40,
    fontWeight: 400,
    lineHeight: 1,
    letterSpacing: '0.044375em',
  },
  h2: {
    fontFamily: 'Lora, sans-serif',
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1,
    letterSpacing: '0.03625em',
  },
  h3: {
    fontFamily: 'Lora, sans-serif',
    fontSize: 28,
    fontWeight: 400,
    lineHeight: 1,
    letterSpacing: '0.03625em',
  },
  h4: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.75,
    letterSpacing: '0.0375em',
  },
  h5: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: '0.03125em',
  },
  h6: {
    fontFamily: 'Lora, sans-serif',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.75,
    letterSpacing: '0.03125em',
  },
  subtitle1: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0em',
  },
  subtitle2: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: '0em',
    textTransform: 'uppercase',
  },
  body1: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.25,
    letterSpacing: '0em',
  },
  body2: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: '0em',
  },
  caption: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: '0em',
  },
};
